import React, { useEffect, useState } from "react";
import DataTable from "../../common/dataTable";
import { Grid, Radio } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import masterActions from "../../redux/master/actions";
import dayjs from "dayjs";
import { itemsPerPage } from "../../utils/constants";
import TablePagination from "../../common/tablePagination";
import Searchbar from "../../common/searchbar";
export default function ObjectionTable() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { backofficeTokenDetails } = useSelector((state) => state.authReducer);

  const [searchTerm, setSearchTerm] = useState("");
  const { objectionList } = useSelector((state) => state.masterReducer);
  const [tableData, setTableData] = useState([]);
  const [itemOffset, setItemOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
    dispatch({ type: masterActions.GET_OJECTION_LIST });
  }, []);

  useEffect(() => {
    createTabledata();
  }, [objectionList, searchTerm]);


  console.log("objectionList________",objectionList);
  
  
  const handleActive = (active, type, objectiontrackerid) => {
    if (type !== active) {
      let data = {
        userid: backofficeTokenDetails?.id,
        objectiontrackerid: objectiontrackerid,
        status: type === "1" ? 1 : 0,
      };
        dispatch({
        type: masterActions.SET_ACTIVE_COURSE,
        payload: { data: data },
      });
    }
  };


  const createTabledata = () => {
    const filtered = objectionList?.data?.filter((obj) =>
    obj.coursename?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    obj.coursedrivename?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    obj.coursecategoryname?.toLowerCase().includes(searchTerm.toLowerCase())
  );

    const data = filtered?.map((obj, index) => ({
      ...obj,
      id: index + 1,
      coursecategory: obj.coursecategoryname,
      coursename: obj.coursename,
      coursedrivename: obj.coursedrivename,
      createddate: dayjs(obj.createddate).format("DD-MM-YYYY"),
      isActive: obj.status === 1,
      enable: (
        <Radio
          checked={obj.status === 1}
          onClick={() => handleActive(obj.status, "1", obj.objectiontrackerid)}
        />
      ),
      disable: (
        <Radio
          checked={obj.status !== 1}
          onClick={() => handleActive(obj.status, "0", obj.objectiontrackerid)}
        />
      ),
    }));

    setTableData(data || []);
  };


  const tableKeys = [
    {
      name: "S.No",
      accessor: "id",
      sortOption: false,
    },
     {
      name: "Drive Name",
      accessor: "coursedrivename",
      sortOption: false,
    },
    {
      name: "Course Category",
      accessor: "coursecategory",
      sortOption: false,
    },
    {
      name: "Course Name",
      accessor: "coursename",
      sortOption: false,
    },
    
    // {
    //   name: "Enable",
    //   accessor: "enable",
    //   sortOption: false,
    // },
    // {
    //   name: "Disable",
    //   accessor: "disable",
    //   sortOption: false,
    // },
  ];

 

  const handleObjectionUpdate = (value) => {
    navigate(
      `/${Cookies.get("mhet_mst_project")}/objection-management?page=updateobjection`,
      { state: { id: value.objectiontrackerid } }
    );
  };

 

  const endOffset = itemOffset + itemsPerPage;
  const currentItems = tableData?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(tableData?.length / itemsPerPage);

  const handlePageChange = (event, value) => {
    const newOffset = (value - 1) * itemsPerPage;
    setItemOffset(newOffset);
    setCurrentPage(value);
  };
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };
  return (
    <Grid>
      <Grid item lg={7} md={7} sm={12} style={{marginBottom:"5px"}}>
        <Searchbar handleSearch={handleSearch} value={searchTerm} />
      </Grid>
      <DataTable
        keys={tableKeys}
        values={currentItems}
        page={"objectionlist"}
        handleObjectionUpdate={handleObjectionUpdate}
      />
      <TablePagination
        pageCount={pageCount}
        handlePageChange={handlePageChange}
        currentPage={currentPage}
      />
    </Grid>
  );
}
